import axios from "axios";
import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useRegisterMutation } from "../../redux/slices/authApiSlice";
import {
  ButtonAuth,
  GoogleAuth,
  InputAuth,
} from "../../shared/components/auth";
import {
  signUpInitialValues as initialValues,
  SignUpSchema as Schema,
} from "./helper";

const SignUp = () => {
  const { t } = useTranslation();
  const [register, { isLoading }] = useRegisterMutation();
  const navigate = useNavigate();
  const [param, setParam] = useSearchParams();
  const ref = useRef();
  const [referralEmail, setReferralEmail] = useState(null);

  useEffect(() => {
    const value = param.get("referral");
    if (value) {
      ref.current.setFieldValue("refferal-code", value);
      ref.current.setFieldValue("refferal", value);
      axios
        .get(`${process.env.REACT_APP_API_URL}/auth/referral-info/${value}`)
        .then((res) => {
          setReferralEmail(res.data.email);
        })
        .catch((err) => {
          console.log("Erreur récupération email du parrain", err);
        });
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("Signup", "S'inscrire")} | BotBlogR</title>
        <meta
          name="description"
          content="Vision générale de votre compte et de vos activités."
        />
      </Helmet>

      {referralEmail && (
        <div className="bg-yellow-500 text-black text-center text-sm px-4 py-2 rounded mb-4">
          <p>Tu es parrainé par {referralEmail}</p>
          <p>
            🎁 Reçois <strong>3 analyses SEO gratuites</strong> en t’inscrivant
            maintenant !
          </p>
        </div>
      )}

      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        innerRef={ref}
        validationSchema={Schema}
        onSubmit={async (values) => {
          try {
            const utmData = JSON.parse(
              localStorage.getItem("utm_data") || "{}"
            );
            const payload = {
              ...values,
              utm: utmData,
            };

            const res = await register(payload).unwrap();

            if (res?.message.includes("successful")) {
              const utmData = JSON.parse(
                localStorage.getItem("utm_data") || "{}"
              );

              // Construction des params UTM dans l'URL seulement s'il y en a
              const utmParams = Object.entries(utmData)
                .filter(([key, value]) => value) // garder seulement les valeurs non nulles / non vides
                .map(
                  ([key, value]) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
                )
                .join("&");

              // URL de base avec uid
              let url = `/confirmation?uid=${encodeURIComponent(res.data.id)}`;

              // Ajouter les utm params s'ils existent
              if (utmParams.length > 0) {
                url += `&${utmParams}`;
              }

              navigate(url);
            }
          } catch (error) {
            toast?.error(error?.data?.detail);
          }
        }}
      >
        {(props) => (
          <div>
            <div>
              <p
                className="text-sm leading-6 text-gray-500 flex items-center gap-3"
                onClick={() => navigate("/login")}
              >
                {t("already-have-account", "Vous avez déjà un compte ?")}
                <span className="cursor-pointer font-semibold text-blue-50  hover:text-blue-200">
                  {t("signin")}
                </span>
              </p>
            </div>
            <div className="mt-5">
              <form action="#" method="POST" className="space-y-6">
                {/* <InputAuth
                  formikProps={props}
                  type="text"
                  text={t("first-name", "Prénom")}
                  name="first_name"
                  placeholder={t("enter-first-name", "Entrez votre prénom")}
                /> */}

                {/* <InputAuth
                  formikProps={props}
                  type="text"
                  text={t("last-name", "Nom de famille")}
                  name="last_name"
                  placeholder={t("enter-last-name", "Entrez votre nom de famille")}
                /> */}

                <InputAuth
                  formikProps={props}
                  type="text"
                  text={t("email", "Email")}
                  name="email"
                  placeholder={t("enter-email", "Entrez votre email")}
                />

                {/* <InputAuth
                  formikProps={props}
                  type="password"
                  text={t("password", "Mot de passe")}
                  name="password"
                  placeholder={t("enter-password", "Entrez votre mot de passe")}
                /> */}

                {/* <InputAuth
                  formikProps={props}
                  type="text"
                  text={t("referral-code", "Code de parrainage")}
                  name="refferal-code"
                  placeholder={t("enter-referral-code", "Entrez votre code de parrainage")}
                /> */}

                <ButtonAuth
                  action={props.handleSubmit}
                  disabled={isLoading}
                  isLoading={isLoading}
                  type="submit"
                  text={t("Register", "S'inscrire")}
                />
              </form>

              <GoogleAuth
                text={t("register", "S'inscrire")}
                btnText={t("register-google", "S'inscrire via Google")}
              />
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default SignUp;
